"use client"

import styled from "@emotion/styled"
import { Desktop, Mobile } from "@eurodrive/ui"
import { sharedColors } from "@eurodrive/ui/theme/colors"
import { extractProperty } from "@eurodrive/utils"
import { getUmbracoMediaUrl } from "@eurodrive/utils/getUmbracoMediaUrl"
import { Typography } from "@mui/material"
import Image from "next/image"

const MainImageBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const ImageContainer = styled.div`
  position: relative;
  height: 400px;
  border-radius: 16px;
  overflow: hidden;
  width: 100%;
`

const formatDate = (dateString: string): string => {
  if (!dateString) return ""

  const date = new Date(dateString)
  if (isNaN(date.getTime())) return dateString // Return original if invalid date

  const day = date.getDate().toString().padStart(2, "0")
  const month = (date.getMonth() + 1).toString().padStart(2, "0")
  const year = date.getFullYear()

  return `${day}/${month}/${year}`
}

export default function ArticleImageBlock({ data }: { data: any }) {
  const imageForDesktop = extractProperty(data, "imageForDesktop")
  const imageForMobile = extractProperty(data, "imageForMobile")
  const imageCredit = extractProperty(data, "imageCredit")
  const imageDate = extractProperty(data, "date")

  return (
    <MainImageBox>
      <ImageContainer>
        {imageForDesktop && (
          <Desktop>
            <Image src={getUmbracoMediaUrl(imageForDesktop)} alt="" fill />
          </Desktop>
        )}
        {imageForMobile && (
          <Mobile>
            <Image src={getUmbracoMediaUrl(imageForMobile)} alt="" fill />
          </Mobile>
        )}
      </ImageContainer>
      <Typography variant="body2" color={sharedColors.mediumGrey}>
        {imageCredit} | {formatDate(imageDate)}
      </Typography>
    </MainImageBox>
  )
}
